// extracted by mini-css-extract-plugin
export var cardWrapper = "_6j-0";